import { NEW_DESIGN_ONLY_FEATURE_FLAG } from "@shared/common/constants";
import { useSelectUser } from "@shared/utils/hooks/misc";
import { IS_WHOP } from "common/constants";

/**
 * Whether the platform is always in the new design, with no way back to the
 * classic look: users with the `new_design_only` feature flag, outside Whop.
 */
const useIsNewLookForced = () => {
  const user = useSelectUser();
  return !IS_WHOP && !!user?.hasFeatureFlag(NEW_DESIGN_ONLY_FEATURE_FLAG);
};

export default useIsNewLookForced;
